import { createElement } from 'react';
import { ConfigProvider as AntConfigProvider } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
const ChineseProvider = ({ children }) => {
    moment.locale('zh-cn');
    return (createElement(AntConfigProvider, { locale: zhCN }, children));
};
ChineseProvider.displayName = 'ChineseProvider';
export default ChineseProvider;
